export default __webpack_public_path__ + "static/media/clash-royale.3c3659db.png";